import { LOCALE } from '../config'

export default {
  name: LOCALE.en,
  plus: {
    table: {
      operate: 'operate'
    }
  }
}
